import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostNullify = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_NULLIFY_JACKPOT
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostNullify as SetPostNullify
}